import InputFile from "components/common/InputFile";
import { Formik } from "formik";
import { useEffect, useState, useMemo } from "react";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import Form from "react-bootstrap/Form";
import { machineImageValidation } from "validations/InspectionRequest";
import PhotoGalleryImg from "assets/images/photo-gallery-img1.png";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  deleteMachineImagesApiCall,
  getMachineImagesApiCall,
  uploadMachineImagesApiCall,
} from "services/inspectionRequest";
import Loader from "components/common/Loader";
import { MESSAGES, VALIDATION } from "constants/messages";
import Swal from "sweetalert2";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";

/**
 * Create a custom component which will render machine images
 * @param props
 * @returns Machine's Images component
 */
export const PhotoGallery = (props) => {
  const [isMutation, setIsMutation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [machineImages, setMachineImages] = useState([]);
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imagesSet, setImagesSet] = useState([]); 
  useEffect(() => {
    fetchMachineImages();
  }, [isMutation]);


  const transformImage = (images) => {
    if(images.length > 0){
    const   updatedImages =  images.map((image) => {
        image.src = image.image_file;
        return image;
      });
      setImagesSet(updatedImages);
    }
  }

  // Fetch the list of images of the machine
  const fetchMachineImages = () => {
    setLoading(true);
    getMachineImagesApiCall(props.machine_id)
      .then((response) => {
        props.setIsMutation(!props.isMutation);
        setMachineImages(response.data);
        transformImage(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  // Upload new image(s) of a machine
  const uploadMachineImages = async (event) => {
    const files = event.target.files;
    if (files && files.length) {
      // Check if all selected files are images
      const areAllFilesImages = Array.from(files).every((file: any) =>
        file.type.startsWith("image/")
      );

      if (!areAllFilesImages) {
        toast.error(VALIDATION.onlyImagesAllowed);
        event.target.value = null;
        return;
      }

      const maxSizeInBytes = 10 * 1024 * 1024; // 10MB (adjust as needed)
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > maxSizeInBytes) {
          toast.error(VALIDATION.imageSizeExceeded);
          event.target.value = null;
          return;
        }
        formData.append("images", files[i]);
      }
      setLoading(true);
      uploadMachineImagesApiCall(formData, props.machine_id)
        .then((response) => {
          toast.success(response.data.message);
          setIsMutation(!isMutation);
          setLoading(false);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          setLoading(false);
        });
    } else {
      event.target.value = null;
    }
  };

  // Delete the image of the machine
  const deleteMachineImage = (id) => {
    setLoading(true);
    deleteMachineImagesApiCall(id)
      .then((response) => {
        toast.success(response.data.message);
        setIsMutation(!isMutation);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  // Handle the delete image - display alert before deleting the image
  const handleDelete = (id) => {
    Swal.fire({
      title: MESSAGES.title,
      text: MESSAGES.text,
      icon: "warning", //MESSAGES.icon,
      showCancelButton: true,
      confirmButtonColor: MESSAGES.confirmButtonColor,
      cancelButtonColor: MESSAGES.cancelButtonColor,
      color: MESSAGES.color,
      confirmButtonText: MESSAGES.deleteIt,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteMachineImage(id);
      }
    });
  };


  const openLightbox = (index) => {
    setPhotoIndex(index);
    setLightboxIsOpen(true);
  };

  const closeLightbox = () => {
    setLightboxIsOpen(false);
  };

  return (
    <>
      <Modal.Body className="photo-gallery-cover">
        <div className="row">
          <div className="col-md-4">
            <label className="photo-gallery-default">
              <InputFile
                controlId="files"
                label=""
                handleChange={uploadMachineImages}
                multiple={true}
                accept="image/*"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48.114"
                height="43.106"
                viewBox="0 0 48.114 43.106"
              >
                <g
                  id="Group_220"
                  data-name="Group 220"
                  transform="translate(-537.434 -195.124)"
                >
                  <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M298.407,382.056c.136.057.272.117.41.171a2.349,2.349,0,0,1,1.627,2.369q0,8.049,0,16.1a1.583,1.583,0,0,1-.1.551.718.718,0,0,1-.741.453.669.669,0,0,1-.653-.5,2.02,2.02,0,0,1-.081-.579q-.007-7.81-.006-15.621a3.714,3.714,0,0,0-.051-.654.728.728,0,0,0-.667-.643,3.189,3.189,0,0,0-.5-.041q-20.167,0-40.335,0c-.939,0-1.24.3-1.24,1.236q0,15.212,0,30.425a3.21,3.21,0,0,0,.036.429.77.77,0,0,0,.717.729,3.178,3.178,0,0,0,.475.029q9.47,0,18.941,0a2.451,2.451,0,0,1,.628.068.727.727,0,0,1,.582.761.78.78,0,0,1-.741.732c-.65.026-1.3.019-1.952.02q-1.986,0-3.973,0c-.1,0-.2.007-.295.007q-4.361,0-8.721,0-2.35,0-4.7-.015a2.356,2.356,0,0,1-2.418-1.659,2.471,2.471,0,0,1-.181-.96q.008-15.462.02-30.924a2.2,2.2,0,0,1,1.079-1.932c.334-.2.693-.366,1.041-.547Z"
                    transform="translate(282.961 -186.932)"
                    fill="#c4c4c4"
                  />
                  <path
                    id="Subtraction_9"
                    data-name="Subtraction 9"
                    d="M-13585.571-2275.728a10.4,10.4,0,0,1-7.095-2.938,9.8,9.8,0,0,1-3.29-6.65,10.452,10.452,0,0,1,3-8.49,10.361,10.361,0,0,1,7.4-3.19c.085,0,.173,0,.27,0a10.544,10.544,0,0,1,6.667,2.414,10.588,10.588,0,0,1,3.672,6.1c.057.3.095.611.125.864l.008.064c.017.136.034.278.055.416a.7.7,0,0,0,.024.1l0,.008c0,.012.008.024.011.036v1.18c-.016.112-.029.224-.043.335-.025.213-.052.432-.091.647a10.146,10.146,0,0,1-6.964,8.435A11.409,11.409,0,0,1-13585.571-2275.728Zm-1.085-9.878h.013a.524.524,0,0,1,.39.112.525.525,0,0,1,.108.393c-.012.884-.021,1.68-.018,2.474v.071a11.126,11.126,0,0,0,.045,1.222.675.675,0,0,0,.733.648h.021a.7.7,0,0,0,.751-.642,2.3,2.3,0,0,0,.034-.385c0-.952,0-1.922,0-2.859,0-.081,0-.162,0-.243,0-.129,0-.276,0-.415a.348.348,0,0,1,.338-.362c.113-.011.219-.017.313-.017q.835,0,1.668,0t1.669,0a1.051,1.051,0,0,0,.724-.287.669.669,0,0,0,.055-.955.92.92,0,0,0-.724-.314c-.766,0-1.544-.006-2.3-.008h-.054l-1.147,0c-.127,0-.253-.009-.374-.017l-.169-.01v-.28q0-.457,0-.914v-.355c0-.709,0-1.442,0-2.16a2.406,2.406,0,0,0-.086-.625.664.664,0,0,0-.689-.542h-.011a.685.685,0,0,0-.709.532,1.944,1.944,0,0,0-.082.556c0,.745,0,1.5,0,2.235v.366q0,.472,0,.945v.27h-2.067c-.7,0-1.249,0-1.781,0a1.892,1.892,0,0,0-.536.072.713.713,0,0,0-.532.8.689.689,0,0,0,.617.672,2.01,2.01,0,0,0,.406.038C-13588.883-2285.6-13587.648-2285.6-13586.656-2285.606Z"
                    transform="translate(14159.766 2513.457)"
                    fill="#c4c4c4"
                    stroke="rgba(0,0,0,0)"
                    stroke-width="1"
                  />
                  <path
                    id="Path_192"
                    data-name="Path 192"
                    d="M277.642,410.572c.288-.375.566-.732.838-1.093q4.1-5.451,8.2-10.9a2.973,2.973,0,0,1,.551-.564.556.556,0,0,1,.783.055,2.506,2.506,0,0,1,.419.531q1.3,2.234,2.585,4.478a.863.863,0,0,1-.018,1.074.793.793,0,0,1-1.289-.184c-.193-.3-.36-.612-.538-.919q-.7-1.218-1.406-2.436c-.083-.142-.177-.277-.287-.447-.3.391-.58.753-.856,1.119q-4.011,5.334-8.022,10.667a3.077,3.077,0,0,1-.423.472.615.615,0,0,1-.831.051,2.679,2.679,0,0,1-.42-.344q-2.613-2.605-5.218-5.219a5.6,5.6,0,0,1-.438-.572l-8.212,9.551c.252.012.452.029.652.029q7.711,0,15.422,0a1.1,1.1,0,0,1,.763.231.738.738,0,0,1-.235,1.278,1.341,1.341,0,0,1-.443.072q-8.87.005-17.739,0a2.02,2.02,0,0,1-.316-.027.638.638,0,0,1-.614-.593,2.383,2.383,0,0,1-.034-.406q0-11.818,0-23.637c0-1.2-.007-2.407-.007-3.61,0-.936.215-1.147,1.151-1.147q18.5,0,37,0a3.882,3.882,0,0,1,.565.037.626.626,0,0,1,.609.6,2.087,2.087,0,0,1,.022.362q0,7.13,0,14.26a1.914,1.914,0,0,1-.088.577.657.657,0,0,1-.681.493.684.684,0,0,1-.714-.517,2.645,2.645,0,0,1-.085-.693q-.007-6.574,0-13.147v-.336h-36.13V414.43l.041.048c.051-.069.1-.14.154-.2q2.42-2.813,4.842-5.625,1.585-1.841,3.169-3.682c.588-.681.938-.687,1.574-.055q2.793,2.778,5.589,5.553C277.548,410.492,277.578,410.516,277.642,410.572Z"
                    transform="translate(280.246 -189.642)"
                    fill="#c4c4c4"
                  />
                  <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M277.6,401.088a4.044,4.044,0,0,1-4.228,4.06,4.093,4.093,0,0,1-3.9-4.1,4.066,4.066,0,0,1,8.132.04Z"
                    transform="translate(276.219 -193.669)"
                    fill="#c4c4c4"
                  />
                </g>
              </svg>
            </label>
          </div>
          <Loader isLoading={loading} />
          {machineImages.length > 0
            ? machineImages?.map((image, index) => (
                <div className="col-md-4">
                  <div className="photo-gallery-img">
                    <a
                      href="javascript:void(0)"
                      onClick={() => handleDelete(image.id)}
                      className="photo-gallery-cross"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                      >
                        <g
                          id="Group_343"
                          data-name="Group 343"
                          transform="translate(-714 -247)"
                        >
                          <circle
                            id="Ellipse_82"
                            data-name="Ellipse 82"
                            cx="15"
                            cy="15"
                            r="15"
                            transform="translate(714 247)"
                            fill="#fff"
                          />
                          <path
                            id="close_circle_outline"
                            data-name="close circle outline"
                            d="M15.224,25.8A10.579,10.579,0,1,1,25.8,15.224,10.593,10.593,0,0,1,15.224,25.8Zm0-23.8A13.224,13.224,0,1,0,28.448,15.224,13.212,13.212,0,0,0,15.224,2Zm3.425,7.935L15.224,13.36,11.8,9.935,9.935,11.8l3.425,3.425L9.935,18.649,11.8,20.514l3.425-3.425,3.425,3.425,1.865-1.865-3.425-3.425L20.514,11.8Z"
                            transform="translate(713.795 246.795)"
                            fill="#fc3232"
                          />
                        </g>
                      </svg>
                    </a>
                    <img src={image.image_file} alt="Photo Gallery"  onClick={() => openLightbox(index)} className="cursor-pointer" />
                  </div>
                </div>
              ))
            : ""}
            
                  {lightboxIsOpen && (
                    <Lightbox
                    index={photoIndex}
                    open={lightboxIsOpen}
                    close={closeLightbox}                    
                    slides={imagesSet.map((slide) => ({
                      ...slide,
                      download: `${slide.src}?response-content-disposition=attachment`,
                    }))}  
                    plugins={[ Fullscreen, Slideshow, Thumbnails, Zoom,Counter,Download]}  
                    counter={{ container: { style: { top: 0 } } }}                 
                  
                  />)}
        </div>
      </Modal.Body>
    </>
  );
};
